/* (ignored) */


//////////////////
// WEBPACK FOOTER
// intl/locale-data/complete.js (ignored)
// module id = 4
// module chunks = polyfills